"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Pi constant.
 * @constant {number} pi
 */
var pi = exports.pi = Math.PI;
/**
 * Double Pi constant.
 * @constant {number} tau
 */

var tau = exports.tau = Math.PI * 2;
/**
 * Half Pi constant.
 * @constant {number} hPi
 */

var hPi = exports.hPi = Math.PI * 0.5;
/**
 * Golden ratio constant.
 * @constant {number} phi
 */

var phi = exports.phi = 1.61803398875;